// src/data/eventTracks.js

// 🌟 기준일 (처음 만난 날 / 사귄 날 등 실제 날짜로 바꿔줘)
export const START_DATE = '2021-11-28'
export const TRACKS = [
    {
        src: '/music/track1.mp3',
        title: '뽀동이라서 다행이야',
        subtitle: '4주년 기념 메인 테마',
        syncedLyrics: [
            // Verse 1
            { time: 0, text: '~~~전주중~~~' },
            { time: 10.50, text: '하루 종일 버티고 집에 돌아오는 길' },
            { time: 15.34, text: '불 꺼진 골목 끝에 네가 떠올라' },
            { time: 20.83, text: '현관문을 열면 나를 반겨주는 두 눈' },
            { time: 26.11, text: '오월이랑 뽀둥이, 내 세상이야' },

            { time: 31.21, text: '힘들었던 말들은 문 앞에 다 벗어 두고' },
            { time: 36.30, text: '네 품 안에 기대어 숨을 고르면' },
            { time: 41.47, text: '아무 것도 안 해도 괜찮다는 그 말에' },
            { time: 46.70, text: '오늘도 내가 살아 있는 것 같아' },

            // Pre-Chorus
            { time: 51.67, text: '작은 집 가득 번지는 웃음소리' },
            { time: 57.03, text: '어제랑 똑같아도 괜찮은 이유' },
            { time: 62.32, text: '밥을 먹고 TV를 보며 눕는 이 시간' },
            { time: 67.60, text: '평범해서 더 기적 같은 밤' },

            // Chorus
            { time: 72.18, text: '오늘도 너라서 다행이야' },
            { time: 77.22, text: '우리 셋이서 손을 잡고 걷는 이 길' },
            { time: 82.58, text: '네가 웃을 때 세상이 환해져' },
            { time: 87.16, text: '오월이와 뽀둥이랑 영원히 같이 살자' },

            { time: 92.32, text: '네 곁에 내가, 내 곁에 네가' },
            { time: 97.30, text: '네 품에서만 내 마음이 편안해져' },
            { time: 102.59, text: '4년을 지나 또 몇 번의 계절이 와도' },
            { time: 107.96, text: '우리 이렇게 웃으면서 살아가자' },

            // Verse 2
            { time: 114.37, text: '주말 아침 늦게까지 잠이 들어도' },
            { time: 119.34, text: '네 숨소리 들리면 괜히 설레어' },
            { time: 124.63, text: '엎드려 자는 너의 머리맡에 기대어' },
            { time: 129.66, text: '“고마워”란 말 속삭이는 나야' },

            { time: 135.10, text: '소파 위에 셋이서 아무 말도 안 해도' },
            { time: 139.93, text: '따뜻하게 포개지는 이 순간이 좋아' },
            { time: 145.04, text: '사진 속에 담긴 우리 웃는 표정들' },
            { time: 150.32, text: '한 장 한 장이 우리 역사 같아' },

            // Pre-Chorus 2
            { time: 155.68, text: '처음 만난 그날을 떠올려 보면' },
            { time: 160.64, text: '어쩌다 이렇게 멀리도 왔을까' },
            { time: 165.68, text: '불안했던 마음을 잡아 준 그 손을' },
            { time: 171.03, text: '이젠 내가 꼭 지켜줄게, 평생' },

            // Chorus (repeat)
            { time: 175.99, text: '오늘도 너라서 다행이야' },
            { time: 181.10, text: '우리 셋이서 손을 잡고 걷는 이 길' },
            { time: 186.13, text: '네가 웃을 때 세상이 환해져' },
            { time: 190.65, text: '오월이와 뽀둥이랑 영원히 같이 살자' },

            { time: 196.08, text: '네 곁에 내가, 내 곁에 네가' },
            { time: 201.11, text: '네 품에서만 내 마음이 편안해져' },
            { time: 206.08, text: '4년을 지나 또 몇 번의 계절이 와도' },
            { time: 211.64, text: '우리 이렇게 웃으면서 살아가자' },

            // Bridge
            { time: 217.98, text: '혹시라도 힘든 날이 온대도' },
            { time: 221.77, text: '내가 먼저 네 손 잡을게' },
            { time: 225.23, text: '“괜찮아, 우리 셋이잖아”' },
            { time: 230.13, text: '그 말 한마디면 다시 시작이야' },

            // Final Chorus
            { time: 235.62, text: '오늘도 너라서 다행이야' },
            { time: 240.59, text: '네 이름 부르며 매일을 노래할게' },
            { time: 245.81, text: '오월이와 뽀둥이, 우리 셋이서' },
            { time: 250.47, text: '이 사랑 끝까지 같이 걸어가자' },

            { time: 255.57, text: '4년 전 그날의 약속처럼' },
            { time: 260.80, text: '지금 이 순간을 다시 기억해 줘' },
            { time: 266.16, text: '앞으로 올 모든 날의 제목은 하나' },
            { time: 271.26, text: '“오월이랑 뽀둥이랑, 영원히 행복하자”' },
        ],
    },
    {
        src: '/music/track2.mp3',
        title: '천방지축 뽀둥 오월',
        subtitle: '로맨틱 코미디 OST',
        syncedLyrics: [
            // Verse 1
            // Verse 1
            { time: 0, text: '~~~전주중~~~' },
            { time: 9.52, text: '지하철 창문에 비친 내 얼굴이' },
            { time: 14.16, text: '오늘따라 조금 더 지쳐 보이네' },
            { time: 19.0, text: '근데 문 열고 “나 왔어” 한마디 하면' },
            { time: 24.38, text: '제일 먼저 뛰어나오는 오월이' },

            { time: 28.84, text: '그 뒤를 따라 느긋하게 걸어오는' },
            { time: 33.61, text: '눈 반짝이는 나의 뽀둥이' },
            { time: 38.26, text: '“오늘 또 뭐 있었는데?” 웃으면서 묻는데' },
            { time: 43.35, text: '그 말 한마디에 다 풀려버려' },

            // Pre-Chorus
            { time: 48.04, text: '오월이는 꼬리로 리듬을 타고' },
            { time: 53.73, text: '뽀둥이는 말로 불꽃놀이를 해' },
            { time: 57.99, text: '조용했던 하루 마지막 장면 위에' },
            { time: 63.29, text: '우리 셋이서 자막을 채워가' },

            // Chorus 1
            { time: 67.8, text: '뽀둥이랑 오월이랑 나,' },
            { time: 70.48, text: '우리 집은 완전 로맨틱 코미디 같아' },
            { time: 73.24, text: '실수해도 웃고, 넘어져도 안아줘' },
            { time: 75.68, text: '엔딩 크레딧은 매일 새로 올라가' },

            { time: 78.17, text: '갑자기 떠오른 생각 쏟아내는 뽀둥이,' },
            { time: 80.34, text: '딱 ENFP 그 느낌이라 웃음 나와' },
            { time: 82.1, text: '귀엽기만 한 오월이가 달려오면' },
            { time: 84.78, text: '세상에서 제일 웃긴 커플 무비야' },

            // Verse 2
            { time: 87.4, text: '주말 아침 알람도 안 맞춰 놨는데' },
            { time: 91.65, text: '옆에서 킥킥대는 너 웃음 소리' },
            { time: 96.42, text: '“이거 봐”라며 폰 화면 들이대는 너' },
            { time: 101.78, text: '구겨진 내 표정도 같이 펴져 가' },

            { time: 106.69, text: '소파 위에 셋이서 아무 말도 없어도' },
            { time: 111.14, text: '오월이는 배 위에, 넌 내 어깨에' },
            { time: 115.97, text: '“이게 바로 행복 아님 뭐야”라고 하면' },
            { time: 119.31, text: '끄덕이다가 살짝 뽀뽀 한 번 더' },

            // Pre-Chorus 2
            { time: 125.78, text: '오월이는 간식 한 마디에 반짝이고' },
            { time: 131.41, text: '뽀둥이는 내 마음에 불을 켜' },
            { time: 135.73, text: '그냥 스쳐 갈 순간들까지 전부 다' },
            { time: 140.83, text: '우리만 아는 베스트 씬이 돼' },

            // Chorus 2
            { time: 145.21, text: '뽀둥이랑 오월이랑 나,' },
            { time: 147.95, text: '우리 집은 오늘도 로코 한 편이야' },
            { time: 150.84, text: '울컥해도 결국, 마지막은 안아줘' },
            { time: 153.18, text: '다음 화 예고는 “내일 또 사랑해”' },

            { time: 155.61, text: '뜻밖의 한마디로 분위기 바꾸는 뽀둥이,' },
            { time: 157.96, text: '내 하루를 통째로 뒤집어 놓고' },
            { time: 160.58, text: '옆에서 졸고 있는 cute 담당 오월이 보면' },
            { time: 162.67, text: '아, 이게 내가 버티는 이유구나' },

            // Bridge
            { time: 165.3, text: '가끔은 나도 겁이 나' },
            { time: 167.79, text: '이 웃음이 혹시 사라질까 봐' },
            { time: 170.14, text: '그때 뽀둥이가 먼저 말해' },
            { time: 172.38, text: '“야, 우리는 이미 해피엔딩이야”' },

            { time: 174.8, text: '오월이가 그 옆에서 하품 한 번 해주면' },
            { time: 177.22, text: '내 걱정도 같이 날아가' },
            { time: 179.32, text: '항상 나 웃게 해주는 뽀둥이 덕분에' },
            { time: 182.08, text: '오늘도, 내일도, 괜찮을 것 같아' },

            // Final Chorus
            { time: 189.01, text: '뽀둥이랑 오월이랑 나,' },
            { time: 191.49, text: '4년째 같은 얘기를 새로 써 내려가' },
            { time: 194.43, text: '손 잡고 웃는 이 마지막 신 위에' },
            { time: 197.57, text: '“이어보기 중” 자막을 남겨 둬' },

            { time: 199.93, text: '세상 누구보다 내 뽀둥이를 사랑해' },
            { time: 201.32, text: '나를 사람답게 만드는 그 웃음소리' },
            { time: 203.88, text: '오월이까지 끼어들어 짖어 주면' },
            { time: 206.04, text: '우리 셋이서 완성하는 러브 코미디' },

            // Outro
            { time: 208.66, text: '뽀둥아, 오월아, 내 옆에 있어 줘' },
            { time: 213.5, text: '평생 너희 덕분에 웃으면서 살게' },
            { time: 215.79, text: '오늘도, 내일도, 또 몇 년이 지나도' },
            { time: 218.61, text: '“뽀둥이랑 오월이랑, 많이 사랑해”' },
        ],
    },
]
